import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("g", { key: '0' },
        React.createElement("circle", { r: '11.94791', cy: '12', cx: '12' }),
        React.createElement("path", { d: 'm20.29514,12.04977l-7.54839,0l0,-7.54839c0,-0.3865 -0.31339,-0.70007 -0.70007,-0.70007s-0.70007,0.31357 -0.70007,0.70007l0,7.54839l-7.54839,0c-0.3865,0 -0.70007,0.31339 -0.70007,0.70007s0.31357,0.70007 0.70007,0.70007l16.49693,0c0.38668,0 0.70007,-0.31339 0.70007,-0.70007s-0.31339,-0.70007 -0.70007,-0.70007l-0.00001,0zm0,0', id: 'svg_6', fill: '#ffffff' }),
        React.createElement("path", { d: 'm18.04542,15.04915l-11.9975,0c-0.38668,0 -0.70007,0.31357 -0.70007,0.70007c0,0.38668 0.31339,0.70007 0.70007,0.70007l11.9975,0c0.38668,0 0.70007,-0.31339 0.70007,-0.70007c0,-0.3865 -0.31339,-0.70007 -0.70007,-0.70007zm0,0', id: 'svg_7', fill: '#ffffff' }),
        React.createElement("path", { d: 'm15.7958,18.0487l-7.49844,0c-0.38668,0 -0.70007,0.31339 -0.70007,0.70007c0,0.3865 0.31339,0.70007 0.70007,0.70007l7.49862,0c0.3865,0 0.70007,-0.31357 0.70007,-0.70007c0,-0.38668 -0.31357,-0.70007 -0.70026,-0.70007l0.00001,0zm0,0', id: 'svg_8', fill: '#ffffff' })),
], 'TransportGroundSensor');
const TransportGroundSensorIcon = function (props) {
    const colors = {
        alarm: '#d32f2f',
        active: '#4caf50',
        disabled: '#9e9e9e',
    };
    return (React.createElement(SvgIcon, Object.assign({ sx: {
            g: {
                fill: colors[props.color],
            },
        } }, props)));
};
export default memo(TransportGroundSensorIcon);
